module.exports = __webpack_public_path__ + "static/logo-b09b1d68a4d3e0c47445c5e9e90ea476.png";